<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-post20-israel-stratotankers-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-post20-israel-stratotankers-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.53225806451613;"
    data-aspect-ratio="0.532"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-post20-israel-stratotankers-xs-img"
      class="g-post20-israel-stratotankers-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post20-israel-stratotankers-xs.jpg);"
    ></div>
    <div
      id="g-ai0-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:11.6905%;margin-top:-17.5px;left:22.2631%;margin-left:-52.5px;width:105px;"
    >
      <p class="g-pstyle0">Mediterranean</p>
      <p class="g-pstyle0">Sea</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:82.2711%;margin-top:-9.1px;left:32.6722%;margin-left:-37px;width:74px;"
    >
      <p class="g-pstyle2">ISRAEL</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-poi-labels g-aiAbs g-aiPointText"
      style="top:46.7873%;margin-top:-9.1px;left:53.5707%;width:134px;"
    >
      <p class="g-pstyle1">Ben Gurion Airport</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-poi-labels g-aiAbs g-aiPointText"
      style="top:43.5615%;margin-top:-9.1px;left:40.4759%;width:67px;"
    >
      <p class="g-pstyle1">Tel Aviv</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-poi-labels g-aiAbs g-aiPointText"
      style="top:27.9163%;margin-top:-9.1px;left:69.2554%;width:88px;"
    >
      <p class="g-pstyle1">Flight path</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-post20-israel-stratotankers-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 0.82258064516129;"
    data-aspect-ratio="0.823"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-post20-israel-stratotankers-sm-img"
      class="g-post20-israel-stratotankers-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post20-israel-stratotankers-sm.jpg);"
    ></div>
    <div
      id="g-ai1-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:11.6905%;margin-top:-17.5px;left:32.0526%;margin-left:-52.5px;width:105px;"
    >
      <p class="g-pstyle0">Mediterranean</p>
      <p class="g-pstyle0">Sea</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:74.5292%;margin-top:-9.1px;left:38.7879%;margin-left:-37px;width:74px;"
    >
      <p class="g-pstyle2">ISRAEL</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:82.755%;margin-top:-9.1px;left:90.8923%;margin-left:-41px;width:82px;"
    >
      <p class="g-pstyle3">JORDAN</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:93.7228%;margin-top:-9.1px;left:6.5623%;margin-left:-34.5px;width:69px;"
    >
      <p class="g-pstyle3">EGYPT</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-poi-labels g-aiAbs g-aiPointText"
      style="top:43.5615%;margin-top:-9.1px;left:43.8373%;width:67px;"
    >
      <p class="g-pstyle1">Tel Aviv</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-poi-labels g-aiAbs g-aiPointText"
      style="top:46.7873%;margin-top:-9.1px;left:52.3104%;width:134px;"
    >
      <p class="g-pstyle1">Ben Gurion Airport</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-poi-labels g-aiAbs g-aiPointText"
      style="top:27.5937%;margin-top:-9.1px;left:57.5574%;width:88px;"
    >
      <p class="g-pstyle1">Flight path</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-post20-israel-stratotankers-md"
    class="g-artboard"
    style="min-width: 660px;aspect-ratio: 1;"
    data-aspect-ratio="1"
    data-min-width="660"
  >
    <div
      id="g-post20-israel-stratotankers-md-img"
      class="g-post20-israel-stratotankers-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post20-israel-stratotankers-md.jpg);"
    ></div>
    <div
      id="g-ai2-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:11.588%;margin-top:-17.5px;left:35.2345%;margin-left:-52.5px;width:105px;"
    >
      <p class="g-pstyle0">Mediterranean</p>
      <p class="g-pstyle0">Sea</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:74.4188%;margin-top:-10.2px;left:40.8182%;margin-left:-41px;width:82px;"
    >
      <p class="g-pstyle2">ISRAEL</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:83.4971%;margin-top:-9.1px;left:90.0864%;margin-left:-41px;width:82px;"
    >
      <p class="g-pstyle3">JORDAN</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:93.3456%;margin-top:-9.1px;left:12.6542%;margin-left:-34.5px;width:69px;"
    >
      <p class="g-pstyle3">EGYPT</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-poi-labels g-aiAbs g-aiPointText"
      style="top:43.6486%;margin-top:-9.1px;left:44.9308%;width:67px;"
    >
      <p class="g-pstyle1">Tel Aviv</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-poi-labels g-aiAbs g-aiPointText"
      style="top:46.8305%;margin-top:-9.1px;left:51.9004%;width:134px;"
    >
      <p class="g-pstyle1">Ben Gurion Airport</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-poi-labels g-aiAbs g-aiPointText"
      style="top:28.1941%;margin-top:-9.1px;left:56.2944%;width:88px;"
    >
      <p class="g-pstyle1">Flight path</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-19 08:36 -->

<!-- Generated by ai2svelte v1.0.3 - 2026-03-19 08:36 -->
<!-- ai file: post20-israel-stratotankers.ai -->
<style lang="scss">
  #g-post20-israel-stratotankers-box {
    container-type: inline-size;
    container-name: g-post20-israel-stratotankers-box;
  }
  #g-post20-israel-stratotankers-box,
  #g-post20-israel-stratotankers-box .g-artboard {
    margin: 0 auto;
  }
  #g-post20-israel-stratotankers-box p {
    margin: 0;
  }
  #g-post20-israel-stratotankers-box .g-aiAbs {
    position: absolute;
  }
  #g-post20-israel-stratotankers-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post20-israel-stratotankers-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-post20-israel-stratotankers-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post20-israel-stratotankers-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-post20-israel-stratotankers-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post20-israel-stratotankers-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post20-israel-stratotankers-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) {
      #g-post20-israel-stratotankers-md {
        display: block !important;
      }
    }
  }
  #g-post20-israel-stratotankers-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post20-israel-stratotankers-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post20-israel-stratotankers-xs .g-pstyle0 {
    font-weight: 400;
    font-style: italic;
    height: 17px;
    text-align: center;
    color: rgb(169, 216, 234);
  }
  #g-post20-israel-stratotankers-xs .g-pstyle1 {
    font-weight: 500;
    height: 17px;
  }
  #g-post20-israel-stratotankers-xs .g-pstyle2 {
    font-weight: 500;
    height: 17px;
    letter-spacing: 0.1em;
    text-align: center;
    color: rgb(102, 102, 102);
  }
  #g-post20-israel-stratotankers-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post20-israel-stratotankers-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post20-israel-stratotankers-sm .g-pstyle0 {
    font-weight: 400;
    font-style: italic;
    height: 17px;
    text-align: center;
    color: rgb(169, 216, 234);
  }
  #g-post20-israel-stratotankers-sm .g-pstyle1 {
    font-weight: 500;
    height: 17px;
  }
  #g-post20-israel-stratotankers-sm .g-pstyle2 {
    font-weight: 500;
    height: 17px;
    letter-spacing: 0.1em;
    text-align: center;
    color: rgb(102, 102, 102);
  }
  #g-post20-israel-stratotankers-sm .g-pstyle3 {
    font-weight: 500;
    height: 17px;
    letter-spacing: 0.1em;
    text-align: center;
    color: rgb(204, 204, 204);
  }
  #g-post20-israel-stratotankers-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post20-israel-stratotankers-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post20-israel-stratotankers-md .g-pstyle0 {
    font-weight: 400;
    font-style: italic;
    height: 17px;
    text-align: center;
    color: rgb(169, 216, 234);
  }
  #g-post20-israel-stratotankers-md .g-pstyle1 {
    font-weight: 500;
    height: 17px;
  }
  #g-post20-israel-stratotankers-md .g-pstyle2 {
    font-weight: 500;
    line-height: 19px;
    height: 19px;
    letter-spacing: 0.1em;
    font-size: 16px;
    text-align: center;
    color: rgb(102, 102, 102);
  }
  #g-post20-israel-stratotankers-md .g-pstyle3 {
    font-weight: 500;
    height: 17px;
    letter-spacing: 0.1em;
    text-align: center;
    color: rgb(204, 204, 204);
  }

  /* Custom CSS */
  @mixin shadow-manchego($clr) {
    $alpha: if(alpha($clr) != 1, alpha($clr), 1);
    text-shadow:
      rgba($clr, $alpha) 1px 0px 0px,
      rgba($clr, $alpha) 0.540302px 0.841471px 0px,
      rgba($clr, $alpha) -0.416147px 0.909297px 0px,
      rgba($clr, $alpha) -0.989992px 0.14112px 0px,
      rgba($clr, $alpha) -0.653644px -0.756802px 0px,
      rgba($clr, $alpha) 0.283662px -0.958924px 0px,
      rgba($clr, $alpha) 0.96017px -0.279415px 0px;
  }
  .g-country-labels,
  .g-poi-labels {
    @include shadow-manchego(#ffffff);
  }
</style>
